var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"change-comparison-card"},[_c('span',{staticClass:"label",attrs:{"title":"同比增长率=（本期数-同期数）/ 同期数"}},[_vm._v(_vm._s(_vm.name))]),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }